'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { WorkerSelectPage } from '../-components/WorkerSelectPage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/worker-roster/targets/')({
  component: WorkerSelectPage
});